import React, { useState, useEffect } from 'react';
import Scheduler from 'devextreme-react/scheduler';
import { fetchOperatorActivity } from '../api';
import { useNavigate, useParams } from 'react-router-dom';
import 'devextreme/dist/css/dx.light.css';
import DailyViewLayout from '../components/DailyViewLayout';
import { Box } from '@mui/material';
import { startOfWeek, endOfWeek, format } from 'date-fns';
import { formatLocalDate, formatSchedulerDate, parseLocalDateTime, parseSchedulerDateTime } from '../utils/localDateTime';

const transformActivityData = (data) => data.map((activity, index) => ({
    id: index,
    text: activity.operator_name,
    startDate: parseSchedulerDateTime(activity.from_time),
    endDate: parseSchedulerDateTime(activity.to_time),
    operatorId: activity.operator_id,
}));

const OperatorSchedulePage = () => {
    const [activities, setActivities] = useState([]);
    const [currentView, setCurrentView] = useState('week');
    const navigate = useNavigate();
    const { date } = useParams();
    const selectedDate = date || formatLocalDate(new Date());

    useEffect(() => {
        console.log('currentView:', currentView, 'selectedDate:', selectedDate);
        if (!date || date !== selectedDate) {
            navigate(`/chart/daily/operator-schedule/${selectedDate}`);
            return;
        }

        const loadData = async () => {
            try {
                let data;
                if (currentView === 'week') {
                    const weekStart = format(startOfWeek(parseLocalDateTime(`${selectedDate}T00:00:00`), { weekStartsOn: 1 }), 'yyyy-MM-dd');
                    const weekEnd = format(endOfWeek(parseLocalDateTime(`${selectedDate}T00:00:00`), { weekStartsOn: 1 }), 'yyyy-MM-dd');
                    console.log('fetchOperatorActivity params:', undefined, weekStart, weekEnd);
                    data = await fetchOperatorActivity(undefined, weekStart, weekEnd);
                } else {
                    console.log('fetchOperatorActivity params:', selectedDate);
                    data = await fetchOperatorActivity(selectedDate);
                }
                const transformedData = transformActivityData(data);
                setActivities(transformedData);
            } catch (error) {
                console.error('Error loading operator activity:', error);
            }
        };

        loadData();
    // eslint-disable-next-line
    }, [date, selectedDate, navigate, currentView]);

    const schedulerProps = {
        dataSource: activities,
        views: ['day', 'week', 'timelineDay'],
        currentView,
        onCurrentViewChange: setCurrentView,
        currentDate: parseSchedulerDateTime(`${selectedDate}T00:00:00`),
        timeZone: 'UTC',
        width: '100%',
        groups: ['operatorId'],
        // cellDuration: 360,
        startDayHour: 6,
        endDayHour: 20,
        resourceCellRender: (model) => model.data.text,
        onCurrentDateChange: (newDate) => {
            const formattedDate = formatSchedulerDate(newDate);
            navigate(`/chart/daily/operator-schedule/${formattedDate}`);
        },
        editing: {
            allowAdding: false,
            allowUpdating: false,
            allowDeleting: false
        },
        resources: [{
            fieldExpr: 'operatorId',
            dataSource: Object.values(activities.reduce((acc, curr) => {
                if (!acc[curr.operatorId]) {
                    acc[curr.operatorId] = { id: curr.operatorId, text: curr.text };
                }
                return acc;
            }, {}))
        }]
    };

    return (
        <DailyViewLayout date={selectedDate}>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Scheduler {...schedulerProps} style={{ flex: 1, minHeight: 0 }} />
            </Box>
        </DailyViewLayout>
    );
};

export default OperatorSchedulePage;
